export const replaceFileExtension = (src: string, extension: string) => {
  return `${src.split('.')[0]}${extension}`;
};
